<template>
  <div class="disease-detail-main-container">
    <div class="top-button">
      <ReturnButton v-if="isInternal"></ReturnButton>
      <HomeButton v-if="isInternal"></HomeButton>
    </div>
    <div class="disease-detail-main-content" :class="isInternal ?  '': 'not-internal'">
      <DiseaseTitle>{{ keShiName }}</DiseaseTitle>
      <div class="swiper">
        <swiper :options="swiperOption" ref="mySwiper" class="disease-detail-swiper-container">
          <!-- 轮播的图片 -->
          <swiper-slide>
            <div class="disease-detail-swiper-container-disease">
              <span>【典型症状】</span>
              <div class="disease-zhengzhuang"> {{ classicalSymptom }}</div>
              <span>【按摩方法】</span>
              <div class="disease-massage-main">
                <div v-for="(item, index) in diseaseMassageInfo" :key="index"
                     class="disease-massage-description-element">
                  <img :src="require('@/assets/image/diseasePage/massage/' + item.imgUrlName + '.png')" alt="picture"
                       style="width: 28vw;height: 31.5vw;">
                  <span class="disease-massage-description">{{ index + 1 }}.{{ item.description }}</span>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="disease-detail-swiper-container-disease">
              <span>【穴位链接】</span>
              <div class="disease-xuewei-main">
                <div v-for="(item, index) in massageXueWeiList" :key=index
                     class="disease-xuewei-element">
                  <button class="disease-detail-classification-button"
                          :style="' --clickedUrl: url(' + '\'' + `${btnSelected}` + '\'' +'); --imgUrl: url(' + '\'' + `${btnNotSelected}` + '\'' +');'"
                          @click="massageXueWeiClicked(item.xueweiCode)">
                    {{ item.xueweiName }}
                  </button>
                </div>
                <div class="qr-code-main">
                  <canvas id="canvas" />
                  <!--                  <img src="../assets/image/diseasePage/QRCode.png">-->
                  <span style="margin-top: 2rem">扫码随时学按摩</span>
                </div>
              </div>
            </div>
          </swiper-slide>
          <!-- 小圆点分页器 -->
        </swiper>
      </div>
      <div class="swiper-custom-pagination swiper-pagination" slot="pagination"></div>
    </div>
    <div style="bottom: 5vw; position: fixed; left: 48%; width: 7%">
      <img :src="lastPage" v-if="isNextPage" alt="picture" style="width: 100%" />
      <img :src="nextPage" v-if="!isNextPage" alt="picture" style="width: 100%" />
    </div>
  </div>
</template>

<script>
import ReturnButton from "@/components/ReturnButton";
import HomeButton from "@/components/HomeButton";
import DiseaseTitle from "@/components/DiseaseTitle";
import btnNotSelected from '@/assets/image/diseasePage/DiseaseButtonNotSelected.png';
import btnSelected from '@/assets/image/diseasePage/DiseaseButtonSelected.png';
import Swiper, {Navigation, Pagination} from 'swiper';
import lastPage from '@/assets/image/diseasePage/LastPage.png';
import nextPage from '@/assets/image/diseasePage/NextPage.png';
import CommonData from "@/assets/js/CommonData";

Swiper.use([Pagination, Navigation])

export default {
  name: 'DiseaseDetailPage',
  components: {
    HomeButton,
    ReturnButton,
    DiseaseTitle,
  },
  data() {
    let that = this;
    return {
      btnSelected,
      btnNotSelected,
      lastPage,
      nextPage,
      isNextPage: true,
      swiperOption: {
        threshold: 50,
        direction: 'vertical',
        loop: false, // 设置图片循环
        autoplay: false, //设置可自动播放
        pagination: {
          el: '.swiper-pagination',//分页器的类名
          clickable: true, //设置分页小圆点可手动点击
        },
        on: {
          reachBeginning: function () {
            that.isNextPage = true;
          },
          reachEnd: function () {
            that.isNextPage = false;
          },
        },
      },
      massageXueWeiList: [
        {
          name: "合谷穴"
        },
        {
          name: "合谷穴"
        },
        {
          name: "合谷穴"
        },
        {
          name: "合谷穴"
        },
        {
          name: "合谷穴"
        },
      ],
      diseaseMassageInfo: [
        {
          imgUrl: 'testMassage.png',
          description: '用拇指指腹点按合谷30次，力度稍重。'
        },
        {
          imgUrl: 'testMassage.png',
          description: '用拇指指腹点按合谷30次，力度稍重。'
        },
        {
          imgUrl: 'testMassage.png',
          description: '用拇指指腹点按合谷30次，力度稍重。'
        },
        {
          imgUrl: 'testMassage.png',
          description: '用拇指指腹点按合谷30次，力度稍重。'
        },
        {
          imgUrl: 'testMassage.png',
          description: '用拇指指腹点按合谷30次，力度稍重。'
        },
        {
          imgUrl: 'testMassage.png',
          description: '用拇指指腹点按合谷30次，力度稍重。'
        },
      ],
      classicalSymptom: '',
      keShiName: '',
      keShiCode: '',
      isInternal: false
    };
  },
  methods: {
    // scrollEvent: function (e) {
    //   if (e.target.scrollTop + e.target.clientHeight > e.target.scrollHeight) {
    //     console.log("嘿嘿我在底部触发了");
    //     this.swiperOption.allowTouchMove = true;
    //   }
    // },
    massageXueWeiClicked(e) {
      try {
        let currentJingMaiIndex = CommonData.jingmaiList.findIndex(jingmai => jingmai.xueweiList.find(xuwei => xuwei.xueweiCode === e));
        let currentXueweiIndex = CommonData.jingmaiList[currentJingMaiIndex].xueweiList.findIndex(xuwei => xuwei.xueweiCode === e);
        this.$router.push({
          path: '/jingLuoDetailPage',
          query: {
            currentJingMaiIndex,
            currentXueweiIndex,
            internal: this.isInternal
          }
        })
      } catch (e) {
        console.error(e);
      }
    }
  },
  created() {
    let diseaseCode = this.diseaseCode = this.$route.query.diseaseCode;
    let keShiCode = this.keShiCode = this.$route.query.keShiCode;
    this.isInternal = this.$route.query.internal === "true";
    let keShiObj = this.keShiObj = JSON.parse(JSON.stringify(CommonData.keshiList.find(keshi => keshi.keShiCode === keShiCode)));
    this.keShiName = keShiObj.name;
    let diseaseObj = JSON.parse(JSON.stringify(keShiObj.disease.find(disease => disease.diseaseCode === diseaseCode)));

    let {massageXueWeiList, massageInfo, classicalSymptom} = diseaseObj;
    this.massageXueWeiList = massageXueWeiList;
    this.classicalSymptom = classicalSymptom;
    // massageInfo.forEach(info => {
    //   info.imgUrl =
    // })

    this.diseaseMassageInfo = massageInfo;
  },
  mounted() {
    let QRCode = require('qrcode');
    let canvas = document.getElementById('canvas');
    let uriHash = window.location.hash
        .replace("&internal=true", "")
        .replace("?internal=true", "")
        .replace("&internal=false", "");

    const runtimeConfig = window.__APP_CONFIG__ || {};
    const publicBaseUrl = runtimeConfig.publicBaseUrl || window.location.origin + "/";
    QRCode.toCanvas(canvas, publicBaseUrl.replace(/\/?$/, "/") + uriHash, {
      errorCorrectionLevel: 'H',
      type: 'image/jpeg',
      quality: 1,
      margin: 1.5,
      width: window.screen.width * 0.4
    }, function (error) {
      if (error) console.error(error)
      console.log('success!');
    })
  },
  destroyed() {
  }
}
</script>

<style>
.disease-detail-main-container {
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("../assets/image/NormalBg.png");
  display: flex;
  flex-direction: column;
}

.disease-detail-classification {
  display: flex;
  flex-wrap: wrap;
  margin: 7rem 2rem 0 2rem;
}

.disease-xuewei-element {
  align-items: center;
  width: 50%;
  display: flex;
  flex-direction: column;
  margin: 4.2vw 0 1.2vw 0;
  justify-content: space-around;
}

.disease-detail-classification-button {
  height: 7vw;
  width: 20vw;
  background-size: 100% 100%;
  background-color: transparent;
  background-image: var(--imgUrl);
  border: 0;
  font-size: 3.5vw;
  font-family: "PingFang", serif;
  color: #c8c8c8;
  padding: 0 0 0.5vw 0;
}

.disease-detail-classification-button:active {
  background-image: var(--clickedUrl);
  color: #0fffff;
}

.swiper-container.disease-detail-swiper-container {
  height: 120vw;
  margin: 7vw 14vw 0 14vw;
}

.disease-detail-swiper-container-disease {
  overflow: scroll;
  height: 1200px;
  margin: 5vw 0 0 0;
  padding: 0 3vw 0 3vw;
  font-size: 4.2vw;
  font-family: "PingFang", serif;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #0fffff;
}

.swiper-custom-pagination {
  height: 26.5%;
  width: 3vw;
  right: 5.5vw;
  top: 40%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.swiper-custom-pagination .swiper-pagination-bullet {
  border-radius: 30px;
  background: #c8c8c8;
  height: 21vw;
  width: 1.5vw;
  opacity: 1;
}

.swiper-custom-pagination .swiper-pagination-bullet-active {
  border-radius: 30px;
  background: #0fffff;
  height: 21vw;
  width: 1.5vw;
}

.swiper-container {
  background-image: url("../assets/image/diseasePage/DiseaseDetailBg.png");
  background-size: 100% 100%;
  border: 0;
}

.disease-zhengzhuang {
  border-bottom: dashed;
  border-bottom-width: 4px;
  word-wrap: break-word;
  width: 94%;
  color: #c8c8c8;
  margin: 1.2vw 0 2.8vw 2.8vw;
  font-size: 3.5vw;
  text-align: left;
}

.disease-massage-description-element {
  margin-top: 5%;
  display: flex;
  flex-direction: column;
  width: 42%;
}

.disease-massage-description {
  font-size: 2.1vw;
  margin: 1.2vw 0;
}

.disease-massage-main {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  text-align: left;
  color: #c8c8c8;
}

.disease-xuewei-main {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.qr-code-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 7vw 0 0 0;
}

.disease-detail-main-content.not-internal .disease-title-container {
  margin: 15vw 28vw 0 28vw;
}
</style>
